import { IS_PAYTO_CONFIG_DISABLE } from 'config';
import { ADD_TRANSACTION_PAYMENT_METHOD_NAME, METHOD_PAYTO } from 'constants';
import {
  FORM_ADD_PAYTO_MAX_AMOUNT_NAME,
  PAYTO_LOG_TAG,
} from 'features/to/const';
import useAddTransaction from 'hooks/form-add-transaction/useAddTransaction';
import useFormAddTransactionStore from 'hooks/form-add-transaction/useFormAddTransactionStore';
import useFxFormAddTransactionStore from 'hooks/fx/useFxFormAddTransactionStore';
import useCountryConfigUtils from 'hooks/useCountryConfigUtils';
import usePage from 'hooks/usePage';
import { isArray, isEmpty } from 'lodash';
import React, { useEffect } from 'react';
import withAddPaytoAccountsAgreement from './withAddPaytoAccountsAgreement';

const withLoadPaytoAccountsAgreementInitial = (Component) => {
  const LoadPaytoAccountsAgreementInitialComponent =
    withAddPaytoAccountsAgreement((props) => {
      const {
        countryConfig,
        fetchPaytoAccountsAgreementLatest,
        onSelect: onSelectPaytoAccountAgreement,
        checkPaymentMethodItemDisabled,
      } = props || {};

      const {
        paymentMethod,
        isMakePayment: isToMakePayment,
        transactionDetails: TOTransactionDetails,
        paytoAccountInformation,
        paytoAccountsAgreement,
        portalModal,
      } = useFormAddTransactionStore();
      const {
        paymentMethodName: FXPaymentMethodName,
        isMakePayment: isFxMakePayment,
        transactionDetails: FXTransactionDetails,
        getTotalPayAmount,
      } = useFxFormAddTransactionStore();
      const { isAddTransactionPage, isFxAddTransactionPage } = usePage();
      const { getTotalToPay } = useAddTransaction();

      const totalToPay = isAddTransactionPage
        ? getTotalToPay()
        : getTotalPayAmount();

      const TOPaymentMethodName =
        paymentMethod?.[ADD_TRANSACTION_PAYMENT_METHOD_NAME];

      const { getPaymentOptionsConfig } = useCountryConfigUtils(countryConfig);

      const isPaytoBlocked =
        !isEmpty(paytoAccountsAgreement) &&
        isArray(paytoAccountsAgreement) &&
        paytoAccountsAgreement?.some(
          (accountAgreement) => accountAgreement?.blocked
        );

      const accountAgreementMakePayment = isFxAddTransactionPage
        ? FXTransactionDetails?.paytoAgreement
        : TOTransactionDetails?.paytoAgreement;
      const accountAgreementMakePaymentValid =
        !isPaytoBlocked &&
        paytoAccountsAgreement?.find(
          (accountAgreement) =>
            accountAgreement?.paymentAgreementUID ===
              accountAgreementMakePayment?.paymentAgreementUID &&
            accountAgreementMakePayment?.maxAmount >= totalToPay
        );

      const accountAgreementValid =
        !isPaytoBlocked &&
        paytoAccountsAgreement?.find(
          (accountAgreement) =>
            accountAgreement?.paymentAgreementUID ===
              paytoAccountInformation?.id &&
            Number(paytoAccountInformation?.[FORM_ADD_PAYTO_MAX_AMOUNT_NAME]) >=
              totalToPay
        );

      const isCreatePaytoAccount =
        paytoAccountInformation?.id === 'other' ||
        paytoAccountInformation?.id === 'payid';

      const { namePortalModal } = portalModal || {};

      useEffect(() => {
        if (IS_PAYTO_CONFIG_DISABLE) return;
        if (
          !getPaymentOptionsConfig()?.['payToVisible'] &&
          isAddTransactionPage
        )
          return;
        if (
          (isAddTransactionPage && isToMakePayment && TOPaymentMethodName) ||
          (isFxAddTransactionPage && isFxMakePayment && FXPaymentMethodName)
        ) {
          console.log(
            `⭐ ${PAYTO_LOG_TAG} 👉 withLoadPaytoAccountsAgreementInitial ➡️ useEffect ➡️  with makePayment & paymentMethod ↩`,
            TOPaymentMethodName || FXPaymentMethodName
          );
          if (
            TOPaymentMethodName === METHOD_PAYTO ||
            FXPaymentMethodName === METHOD_PAYTO
          ) {
            if (
              !isEmpty(accountAgreementMakePaymentValid) &&
              !namePortalModal
            ) {
              onSelectPaytoAccountAgreement(accountAgreementMakePaymentValid);
              return;
            }
          }
          if (isEmpty(paytoAccountsAgreement)) {
            fetchPaytoAccountsAgreementLatest();
          }
          return;
        }
        if (
          (isAddTransactionPage &&
            !isToMakePayment &&
            !TOPaymentMethodName &&
            !namePortalModal &&
            !checkPaymentMethodItemDisabled(METHOD_PAYTO)) ||
          (isFxAddTransactionPage &&
            !isFxMakePayment &&
            !FXPaymentMethodName &&
            !namePortalModal &&
            !checkPaymentMethodItemDisabled(METHOD_PAYTO))
        ) {
          console.log(
            `⭐ ${PAYTO_LOG_TAG} 👉 withLoadPaytoAccountsAgreementInitial ➡️ useEffect ➡️ WITHOUT makePayment & WITHOUT paymentMethod ↩`
          );
          fetchPaytoAccountsAgreementLatest();
          return;
        }
        if (
          (isAddTransactionPage &&
            !isToMakePayment &&
            TOPaymentMethodName &&
            !isEmpty(paytoAccountInformation) &&
            isEmpty(accountAgreementValid)) ||
          (isFxAddTransactionPage &&
            !isFxMakePayment &&
            FXPaymentMethodName &&
            !isEmpty(paytoAccountInformation) &&
            isEmpty(accountAgreementValid))
        ) {
          console.log(
            `⭐ ${PAYTO_LOG_TAG} 👉 withLoadPaytoAccountsAgreementInitial ➡️ useEffect ➡️ WITHOUT makePayment & paymentMethod ↩`,
            TOPaymentMethodName || FXPaymentMethodName
          );
          if (isCreatePaytoAccount) return;
          onSelectPaytoAccountAgreement();
          return;
        }
      }, [
        isAddTransactionPage,
        isFxAddTransactionPage,
        TOPaymentMethodName,
        FXPaymentMethodName,
        isToMakePayment,
        isFxMakePayment,
        accountAgreementMakePaymentValid,
        // accountAgreementValid,
        isCreatePaytoAccount,
        namePortalModal,
      ]);

      useEffect(() => {
        if (checkPaymentMethodItemDisabled(METHOD_PAYTO)) {
          console.log(
            `⭐ ${PAYTO_LOG_TAG} 👉 useEffect ➡️ fetchPaytoAccountsAgreementLatest ➡️ initial ↩`
          );
          fetchPaytoAccountsAgreementLatest();
        }
      }, []);

      const newProps = {
        ...props,
      };
      return <Component {...newProps} />;
    });
  return LoadPaytoAccountsAgreementInitialComponent;
};

export default withLoadPaytoAccountsAgreementInitial;
